import React from 'react';
import { MenuItem, Select, Typography } from '@mui/material';
import { COMPANIES, FUND, FUNDS, NO_ITEMS_AVAILABLE } from 'common/constants/user';
import { CompanyFundSelectProps } from './CompanyFundSelect.props';

const CompanyFundSelect = ({
  value,
  handleSelect,
  itemType,
  itemList,
  size,
  variant = 'standard',
}: CompanyFundSelectProps) => (
  <>
    <Select
      disabled={itemList?.length === 0}
      fullWidth
      size={size}
      id={`${itemType.toLowerCase()}-select`}
      value={value ?? ''}
      onChange={event =>
        handleSelect({
          itemType,
          itemId: event.target.value as number,
        })
      }
      variant={variant}>
      {itemList.map(item => (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
    {itemList?.length === 0 && (
      <Typography variant="caption">{NO_ITEMS_AVAILABLE(itemType === FUND ? FUNDS : COMPANIES)}</Typography>
    )}
  </>
);

export default CompanyFundSelect;
